// extracted by mini-css-extract-plugin
module.exports = {"label":"selectize-module_label_89433","required":"selectize-module_required_4ffcf","wrapper":"selectize-module_wrapper_a6411","closeIcon":"selectize-module_closeIcon_ee5c5"};